export const children = {
  title: 'My children',
  addChild: 'Add child',
  noChildren: 'No children added',
  noChildrenBody: 'Link your child to follow their progress.',
  whatYoullSee: "What you'll see",
  sampleTag: 'Sample',
  sampleNoticeTitle: 'This is a sample.',
  sampleNoticeBody: 'Link your child to see their real progress.',
  acceptRequest: 'Accept child request',
  declineRequest: 'Decline child request',
  cancelRequest: 'Cancel parent link request',
  acceptRequestCta: 'Accept request',
  declineRequestCta: 'Decline',
  cancelRequestCta: 'Cancel request',
  linkRequestPending: 'Link request pending your approval',
  waitingForChild: 'Waiting for {childName} to accept parent request on student app',
  yourChild: 'your child',
  showCode: 'Show code',
  cancelRequestTitle: 'Cancel this request?',
  cancelRequestBody: 'The link request for {childName} will be cancelled.',
  cancelRequestConfirm: 'Yes, Cancel',
  thisChild: 'this child',

  mathWithLevel: '{level} Math',
  math: 'Math',
  chaptersCompleted: '{done} of {total} chapters completed',
  noDataYet: 'No data yet',
  dailyAverage: 'Daily average',
  accuracy: 'Accuracy',
  minsShort: '{mins} min',

  statusCompleted: 'Completed',
  statusStarted: 'In progress',
  statusPending: 'Not started',
  metaAssigned: 'Assigned {date}',
  metaStarted: 'Started {date}',
  metaDone: 'Done {date}',
  metaCorrect: '{correct}/{total} correct',

  linkYourChild: 'Link your child',
  linkYourChildBody:
    'Ask your child to open Tupai, go to Profile and enter this code under "Have a code from a parent?"',
  linkYourChildAlt: 'Or ask your child to send you their link.',
  yourCode: 'Your code',
  couldNotLoadCode: "Couldn't load your code.",
  retry: 'Retry',
  expiresIn: 'Expires in {timeLeft}',
  expired: 'Expired',
  copied: 'Copied',
  copy: 'Copy',
  newCode: 'New code',
  consentTitle: 'Give consent and link {hasName, select, true {{childName}} other {your child}}',
  consentIntro:
    "Tupai needs a parent's consent to link any student. Once linked, you can see {hasName, select, true {{childName}} other {your child}}'s learning progress. {hasName, select, true {{childName}} other {Your child}} is told when you link.",
  consentCollectsTitle: 'What Tupai collects from your child',
  consentCollectsIntro:
    'Tupai is a maths learning app. To provide it, we collect and use the following about your child:',
  consentCollectsList:
    'Phone number (to sign in) · Name and age · School name · Learning activity and progress',
  consentCollectsUse:
    "This is used only to run the learning service. Tupai shows no advertising and never sells your child's information.",
  consentPrivacyLead: 'See the',
  consentPrivacyLink: 'Privacy Policy',
  consentSeeTitle: "What you'll see",
  consentSeeBody:
    "{hasName, select, true {{childName}} other {Your child}}'s activity, reports and accuracy. Not their messages or contacts.",
  consentCheckbox:
    "I am {hasName, select, true {{childName}} other {my child}}'s parent or legal guardian, and I consent to Tupai collecting and using their information as described above.",
  consentNameLabel: "Your child's name",
  consentNamePlaceholder: 'A nickname or a real name',
  consentNameHint: 'Your child sees this name in Tupai.',
  consentNameError: "Enter your child's name.",
  consentNameTooLong: 'Use up to 100 characters.',
  consentAgree: 'Consent and link',
  consentCancel: 'Not now',
  approveBlockedSeatBody:
    'Your plan has no free seat for {hasName, select, true {{childName}} other {your child}}. Change your plan first, then accept the request.',
  approveBlockedSyllabusBody:
    'The syllabus {hasName, select, true {{childName}} other {your child}} studies needs a higher plan. Change your plan first, then accept the request.',
  approveBlockedWaiting:
    'The request from {hasName, select, true {{childName}} other {your child}} stays here until you accept or decline it.',
  errStudentAlreadyLinked:
    'This child is already linked to a parent. A child can have only one linked parent at a time — they’ll need to unlink first, then share a new code with you.',

  planOfferTitle: 'Upgrade for AI reports and homework',
  planOfferBody: 'Try Family Solo free for {days} days. Cancel anytime.',
  planOfferCta: 'Start free trial',
  planOfferEndedTitle: 'Your free trial has ended',
  planOfferEndedBody: 'Choose a plan to get AI reports and homework back.',
  planOfferEndedCta: 'Choose a plan',
  coveredByPlan: 'Covered by your plan',
  seatCheckOffline: 'No connection. Check your internet and try again.',
  notCoveredByPlan: 'Not covered by a plan',
  overPlanLimit: "Over your plan's limit",

  unlinkTitle: 'Unlink {childName}?',
  unlinkBody: "You'll stop seeing {childName}'s progress. Here's what happens:",
  unlinkKeepsAccount: '{childName} keeps their student account and all their progress.',
  unlinkKeepsHistory: 'Your reports and homework history are kept, in case you re-link.',
  unlinkNeedsNewCode: 'Re-linking later needs a new code from their app.',
  unlinkConfirm: 'Unlink {childName}',
  keepLinked: 'Keep linked',

  railChildrenCount:
    '{pending, plural, =0 {{linked} linked} other {{linked} linked · {pending} pending}}',
} as const;
